export const bmTooljs = {
	// 数据类型判断
	judgeType: function(data) {
		if (arguments.length == 0) {
			return '0' // 无参数传入
		}
		if (data === null) {
			return 'null'
		}
		if (data === undefined && arguments.length > 0) {
			return 'undefined'
		}
		if (data instanceof Function) {
			return 'function'
		}
		if (data instanceof Array) {
			return 'array'
		}
		if (Object.prototype.toString.call(data).slice(8, -1) === 'Object') {
			return 'object'
		}
		if (data instanceof Number || typeof data == 'number') {
			return 'number'
		}
		if (data instanceof String || typeof data == 'string') {
			return 'string'
		}
		if (data instanceof Boolean || typeof data == 'boolean') {
			return 'boolean'
		}
	},

	// 数据去除空格
	spaceFilter: function(data) {
		return data.replace(/\s+/g, '')
	},

	// 滚动到顶部
	scrollToTop: function() {
		var c = document.documentElement.scrollTop || document.body.scrollTop
		if (c > 0) {
			window.requestAnimationFrame(scrollToTop)
			window.scrollTo(0, c - c / 8)
		}
	},

	// 获取滚动的坐标
	getScrollPosition: function(el) {
		return {
			x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
			y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
		}
	},

	// 生成范围随机数
	random: function(min, max) {
		if (arguments.length === 2) {
			return Math.floor(min + Math.random() * (max + 1 - min))
		} else {
			return null
		}
	},

	// 判断一个元素是否在数组中
	contains: function(arr, val) {
		return arr.indexOf(val) != -1 ? true : false
	},

	// 数组排序 {type} 1：从小到大 2：从大到小 3：随机
	sorts: function(arr, type) {
		return arr.sort(function(a, b) {
			switch (type) {
				case 1:
					return a - b
				case 2:
					return b - a
				case 3:
					return Math.random() - 0.5
				default:
					return arr
			}
		})
	},

	// 数组去重
	unique: function(arr) {
		if (Array.hasOwnProperty('from')) {
			return Array.from(new Set(arr))
		} else {
			var n = {},
				r = []
			for (var i = 0; i < arr.length; i++) {
				if (!n[arr[i]]) {
					n[arr[i]] = true
					r.push(arr[i])
				}
			}
			return r
		}
	},

	// 根据url地址下载
	download: function(url) {
		var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1
		var isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1
		if (isChrome || isSafari) {
			var link = document.createElement('a')
			link.href = url
			if (link.download !== undefined) {
				var fileName = url.substring(url.lastIndexOf('/') + 1, url.length)
				link.download = fileName
			}
			if (document.createEvent) {
				var e = document.createEvent('MouseEvents')
				e.initEvent('click', true, true)
				link.dispatchEvent(e)
				return true
			}
		}
		if (url.indexOf('?') === -1) {
			url += '?download'
		}
		window.open(url, '_self')
		return true
	},

	// 深拷贝
	deepCopy: function(source, type) {
		let stringify = JSON.stringify(source)
		return JSON.parse(stringify)
	},

	// 取地址栏参数
	getUrlParams: function(url) {
		var search = url.split('?')[1]
		if (!search) {
			return {}
		}
		return JSON.parse(
			'{"' +
				decodeURIComponent(search)
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
				'"}'
		)
	},

	// 动态引入js
	injectScript: function(src, id, defer) {
		var s = document.createElement('script')
		s.type = 'text/javascript'
		s.async = true
		s.src = src
		s.defer = defer
		if (id) s.id = id
		var t = document.getElementsByTagName('script')[0]
		t.parentNode.insertBefore(s, t)
	},

	// el是否在视口范围内
	elementIsVisibleInViewport: function(el, partiallyVisible = false) {
		var { top, left, bottom, right } = el.getBoundingClientRect()
		var { innerHeight, innerWidth } = window
		return partiallyVisible
			? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
					((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
			: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
	},

	// 劫持粘贴板
	copyTextToClipboard: function(value) {
		var textArea = document.createElement('textarea')
		textArea.style.background = 'transparent'
		textArea.value = value
		document.body.appendChild(textArea)
		textArea.select()
		try {
			var successful = document.execCommand('copy')
		} catch (err) {
			console.log('Oops, unable to copy')
		}
		document.body.removeChild(textArea)
	},

	// 将阿拉伯数字翻译成中文的大写数字
	numberToChinese: function(num) {
		var AA = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十')
		var BB = new Array('', '十', '百', '仟', '萬', '億', '点', '')
		var a = ('' + num).replace(/(^0*)/g, '').split('.'),
			k = 0,
			re = ''
		for (var i = a[0].length - 1; i >= 0; i--) {
			switch (k) {
				case 0:
					re = BB[7] + re
					break
				case 4:
					if (!new RegExp('0{4}//d{' + (a[0].length - i - 1) + '}$').test(a[0])) re = BB[4] + re
					break
				case 8:
					re = BB[5] + re
					BB[7] = BB[5]
					k = 0
					break
			}
			if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re
			if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re
			k++
		}

		if (a.length > 1) {
			// 加上小数部分(如果有小数部分)
			re += BB[6]
			for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)]
		}
		if (re == '一十') re = '十'
		if (re.match(/^一/) && re.length == 3) re = re.replace('一', '')
		return re
	},

	// 将数字转换为大写金额
	changeToChinese: function(money) {
		var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖') //汉字的数字
		var cnIntRadice = new Array('', '拾', '佰', '仟') //基本单位
		var cnIntUnits = new Array('', '万', '亿', '兆') //对应整数部分扩展单位
		var cnDecUnits = new Array('角', '分', '毫', '厘') //对应小数部分单位
		var cnInteger = '整' //整数金额时后面跟的字符
		var cnIntLast = '元' //整型完以后的单位
		var maxNum = 999999999999999.9999 //最大处理的数字
		var IntegerNum //金额整数部分
		var DecimalNum //金额小数部分
		var ChineseStr = '' //输出的中文金额字符串
		var parts //分离金额后用的数组，预定义
		var Symbol = '' //正负值标记
		if (money == '') {
			return ''
		}

		money = parseFloat(money)
		if (money >= maxNum) {
			console.warn('超出最大处理数字')
			return ''
		}
		if (money == 0) {
			ChineseStr = cnNums[0] + cnIntLast + cnInteger
			return ChineseStr
		}
		if (money < 0) {
			money = -money
			Symbol = '负 '
		}
		money = money.toString() //转换为字符串
		if (money.indexOf('.') == -1) {
			IntegerNum = money
			DecimalNum = ''
		} else {
			parts = money.split('.')
			IntegerNum = parts[0]
			DecimalNum = parts[1].substr(0, 4)
		}
		if (parseInt(IntegerNum, 10) > 0) {
			//获取整型部分转换
			var zeroCount = 0
			var IntLen = IntegerNum.length
			for (var i = 0; i < IntLen; i++) {
				var n = IntegerNum.substr(i, 1)
				var p = IntLen - i - 1
				var q = p / 4
				var m = p % 4
				if (n == '0') {
					zeroCount++
				} else {
					if (zeroCount > 0) {
						ChineseStr += cnNums[0]
					}
					zeroCount = 0 //归零
					ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
				}
				if (m == 0 && zeroCount < 4) {
					ChineseStr += cnIntUnits[q]
				}
			}
			ChineseStr += cnIntLast
			//整型部分处理完毕
		}
		if (DecimalNum != '') {
			//小数部分
			var decLen = DecimalNum.length
			for (var i = 0; i < decLen; i++) {
				var n = DecimalNum.substr(i, 1)
				if (n != '0') {
					ChineseStr += cnNums[Number(n)] + cnDecUnits[i]
				}
			}
		}
		if (ChineseStr == '') {
			ChineseStr += cnNums[0] + cnIntLast + cnInteger
		} else if (DecimalNum == '') {
			ChineseStr += cnInteger
		}
		ChineseStr = Symbol + ChineseStr

		return ChineseStr
	},

	// 去除html标签
	removeHtmltag: function(str) {
		return str.replace(/<[^>]+>/g, '')
	},

	// 判断两个对象是否键值相同
	isObjectEqual: function(a, b) {
		var aProps = Object.getOwnPropertyNames(a)
		var bProps = Object.getOwnPropertyNames(b)

		if (aProps.length !== bProps.length) {
			return false
		}

		for (var i = 0; i < aProps.length; i++) {
			var propName = aProps[i]

			if (a[propName] !== b[propName]) {
				return false
			}
		}
		return true
	},

	// 追加url参数
	appendQuery: function(url, key, value) {
		var options = key
		if (typeof options == 'string') {
			options = {}
			options[key] = value
		}
		options = $.param(options)
		if (url.includes('?')) {
			url += '&' + options
		} else {
			url += '?' + options
		}
		return url
	},

	// base64解码
	base64_decode: function(data) {
		var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		var o1,
			o2,
			o3,
			h1,
			h2,
			h3,
			h4,
			bits,
			i = 0,
			ac = 0,
			dec = '',
			tmp_arr = []
		if (!data) {
			return data
		}
		data += ''
		do {
			h1 = b64.indexOf(data.charAt(i++))
			h2 = b64.indexOf(data.charAt(i++))
			h3 = b64.indexOf(data.charAt(i++))
			h4 = b64.indexOf(data.charAt(i++))
			bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4
			o1 = (bits >> 16) & 0xff
			o2 = (bits >> 8) & 0xff
			o3 = bits & 0xff
			if (h3 == 64) {
				tmp_arr[ac++] = String.fromCharCode(o1)
			} else if (h4 == 64) {
				tmp_arr[ac++] = String.fromCharCode(o1, o2)
			} else {
				tmp_arr[ac++] = String.fromCharCode(o1, o2, o3)
			}
		} while (i < data.length)
		dec = tmp_arr.join('')
		dec = utf8_decode(dec)
		return dec
	},

	// 字符串长度截取
	cutstr: function(str, len) {
		var temp,
			icount = 0,
			patrn = /[^\x00-\xff]/,
			strre = ''
		for (var i = 0; i < str.length; i++) {
			if (icount < len - 1) {
				temp = str.substr(i, 1)
				if (patrn.exec(temp) == null) {
					icount = icount + 1
				} else {
					icount = icount + 2
				}
				strre += temp
			} else {
				break
			}
		}
		return strre + '...'
	},

	// 日期格式转换
	dateformat: function(dateTime, format) {
		// format yyyy-MM-dd hh:mm:ss
		if (Object.prototype.toString.call(dateTime) === '[object Date]') {
			dateTime = dateTime.getTime()
		}
		if (Object.prototype.toString.call(dateTime) === '[object String]') {
			let time = new Date(dateTime)
			let month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
			let day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
			dateTime = time.getFullYear() + '-' + month + '-' + day
			dateTime = new Date(dateTime).getTime()
		}
		dateTime = new Date(dateTime)
		var o = {
			'M+': dateTime.getMonth() + 1, // month
			'd+': dateTime.getDate(), // day
			'h+': dateTime.getHours(), // hour
			'm+': dateTime.getMinutes(), // minute
			's+': dateTime.getSeconds(), // second
			'q+': Math.floor((dateTime.getMonth() + 3) / 3), // quarter
			S: dateTime.getMilliseconds() // millisecond
		}
		if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (dateTime.getFullYear() + '').substr(4 - RegExp.$1.length))
		for (var k in o) {
			if (new RegExp('(' + k + ')').test(format))
				format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
		}
		return format
	},

	// 年月日
	dateformatChinese: function(dateTime, char) {
		var time = new Date(dateTime)
		var year = da.getFullYear() + '年'
		var month = da.getMonth() + 1 + '月'
		var date = da.getDate() + '日'
		return [year, month, date].join(char)
	},

	// 季度转换 returnType: 1 2
	dateformatQuarter: function(dateTime, returnType) {
		var quarterString
		var month = new Date(dateTime).getMonth() + 1

		if (returnType === 1) {
			switch (month) {
				case 1:
					quarterString = 1
					break
				case 4:
					quarterString = 2
					break
				case 7:
					quarterString = 3
					break
				case 10:
					quarterString = 4
					break
			}
		}
		if (returnType === 2) {
			switch (month) {
				case 1:
					quarterString = '一'
					break
				case 4:
					quarterString = '二'
					break
				case 7:
					quarterString = '三'
					break
				case 10:
					quarterString = '四'
					break
			}
		}

		return quarterString
	},

	// 对象数据拼接
	objectJoin: function(newData, oldData) {
		var obj = oldData
		Object.keys(obj).map(i => {
			Object.keys(newData).map(x => {
				if (i === x) {
					obj[i] = newData[x]
				}
			})
		})

		return obj
	},

	// 倒计时
	timeRemaining: function(endTime, startTime) {
		var date1 = startTime || new Date() // 开始时间
		var date2 = new Date(endTime) // 结束时间
		var date3 = date2.getTime() - new Date(date1).getTime() // 时间差的毫秒数
		// 计算出相差天数
		var days = Math.floor(date3 / (24 * 3600 * 1000))
		// 计算出小时数
		var leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
		var hours = Math.floor(leave1 / (3600 * 1000))
		// 计算相差分钟数
		var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
		var minutes = Math.floor(leave2 / (60 * 1000))
		// 计算相差秒数
		var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
		var seconds = Math.round(leave3 / 1000)

		return {
			text: days + '天 ' + hours + '小时 ' + minutes + ' 分钟 ' + seconds + ' 秒',
			ms: date3
		}
	},

	// 数字转换万元
	conversionThousand: function(amount) {
		var amountNum = amount || 0
		if (amountNum === '') amountNum = 0
		if (bmTooljs.judgeType(parseFloat(amountNum)) === 'number') {
			if (amount < 10000) return amount
			return amount / 10000 + '万元'
		} else {
			return ''
		}
	},

	// 数组元素互换位置
	swapArr: function(arr, index1, index2) {
		arr[index1] = arr.splice(index2, 1, arr[index1])[0]
		return arr
	},

	// 自定义对象属性拼接
	objectAttributeStitch: function(originalObject, targetObject, arr) {
		// bmTooljs.objectAttributeStitch(original, target, [
		// 	{ target: 'priceCeiling', original: 'priceCeiling' },
		// 	{ target: 'bedgetMoney', original: 'bedgetMoney' }
		// ])
		let oj = bmTooljs.deepCopy(originalObject)
		let tj = bmTooljs.deepCopy(targetObject)

		arr.map(i => {
			switch (i.type) {
				case 'number':
					tj[i.target] = parseFloat(oj[i.original])
					break
				case 'string':
					tj[i.target] = oj[i.original].toString()
					break
				default:
					tj[i.target] = oj[i.original]
					break
			}
		})

		return tj
	},

	// 距离某个时间剩余
	countDown: function(o) {
		if (!o) return ''
		var datatime = /^[\d]{4}-[\d]{1,2}-[\d]{1,2}( [\d]{1,2}:[\d]{1,2}(:[\d]{1,2})?)?$/gi,
			str = '',
			conn,
			s
		if (!o.match(datatime)) {
			// alert('参数格式为2020-01-01[ 01:01[:01]].\r其中[]内的内容可省略')
			return false
		}
		var sec = (new Date(o.replace(/-/gi, '/')).getTime() - new Date().getTime()) / 1000
		if (sec > 0) {
			conn = '还有'
		} else {
			conn = '已过去'
			sec *= -1
			return '已结束'
		}
		s = { 天: sec / 24 / 3600, 小时: (sec / 3600) % 24, 分: (sec / 60) % 60, 秒: sec % 60 }

		Object.keys(s).map(i => {
			if (Math.floor(s[i]) > 0) str += Math.floor(s[i]) + i
		})
		if (Math.floor(sec) == 0) {
			str = '0秒'
		}
		return conn + str
	}
}

var sessionStorage = window.sessionStorage
var localStorage = window.localStorage

export const bmStorage = {
	localStorage: {
		get: function(name) {
			if (localStorage) {
				if (name == null || typeof name === 'undefined' || name === 'undefined' || name === '') {
					return ''
				} else {
					return localStorage.getItem(name)
				}
			}
		},
		set: function(name, val) {
			if (localStorage) {
				localStorage.setItem(name, val)
			}
		},
		clear: function() {
			if (localStorage) {
				localStorage.clear()
			}
		},
		remove: function(name) {
			if (localStorage) {
				localStorage.removeItem(name)
			}
		}
	},

	sessionStorage: {
		get: function(name) {
			return sessionStorage.getItem(name)
		},
		set: function(name, val) {
			sessionStorage.setItem(name, val)
		},
		clear: function() {
			sessionStorage.clear()
		},
		remove: function(name) {
			sessionStorage.removeItem(name)
		}
	},

	cookie: {
		get: function(name) {
			var arr,
				reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
			if ((arr = document.cookie.match(reg))) {
				return arr[2]
			} else {
				return false
			}
		},
		set: function(name, value, day) {
			var Days = day
			var exp = new Date()
			exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
			document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
		},
		remove: function(name) {
			var exp = new Date()
			exp.setTime(exp.getTime() - 1)
			var cval = getCookie(name)
			if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./static/commonplugin/tool.js
// module id = Ex/p
// module chunks = 13